export const presenceModuleStatus = Object.freeze({
  DEACTIVATED: 'deactivated',
  READABLE: 'readable',
  EDITABLE: 'editable',
});
